import styled from 'styled-components'
import { media } from '../theme'
import { Form as FormikForm } from 'formik'

const Form = styled(FormikForm)`
  display: flex;
  flex-direction: column;
  width: 100%;

  ${media.greaterThan('medium')`
    width: ${p => (p.fullWidth ? '100%' : '75%')};
  `};
`

export default Form



// WEBPACK FOOTER //
// ./src/components/Form.js